// These are from the db.
export enum TestStatus {
    NotStarted = 1,
    InProgress = 2,
    Passed = 3,
    Failed = 4,
    Queued = 5,
    Canceled = 6,
    PassedWithWarnings = 7,
};

const names = {
    "NotStarted": TestStatus.NotStarted,
    "InProgress": TestStatus.InProgress,
    "Passed": TestStatus.Passed,
    "Failed": TestStatus.Failed,
    "Queued": TestStatus.Queued,
    "Canceled": TestStatus.Canceled,
    "PassedWithWarnings": TestStatus.PassedWithWarnings,
}

export const TestStatusGetID = (status: string | TestStatus): TestStatus => {
   return names[status] || status;
};